import abi from './abi.json'
const address = "0xdac17f958d2ee523a2206206994597c13d831ec7"
const usdt = {abi,address}
export default usdt